/**
 * @generated SignedSource<<5a2a4f967b68a1a04f2718aa782ddc04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AccountEditDeleteAccountMutation$variables = {
  id: string;
  storeId?: string | null;
};
export type AccountEditDeleteAccountMutation$data = {
  readonly store: {
    readonly storeUser: {
      readonly remove: boolean | null;
    } | null;
  };
};
export type AccountEditDeleteAccountMutation = {
  response: AccountEditDeleteAccountMutation$data;
  variables: AccountEditDeleteAccountMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "storeId"
      }
    ],
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": "StoreUserMutation",
        "kind": "LinkedField",
        "name": "storeUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remove",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountEditDeleteAccountMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountEditDeleteAccountMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "20d026af27050433f124cda399779c31",
    "id": null,
    "metadata": {},
    "name": "AccountEditDeleteAccountMutation",
    "operationKind": "mutation",
    "text": "mutation AccountEditDeleteAccountMutation(\n  $id: ID!\n  $storeId: ID\n) {\n  store(id: $storeId) {\n    storeUser(id: $id) {\n      remove\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "782d93e752b5c83a30745c8c7bdccf1c";

export default node;
